import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { whitelistedConfigurationSettingSchema } from '../schemas/whitelisted-configuration-setting.schema';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get a list of Whitelisted Configuration Settings for a specified application
 * @param applicationId ID of Application
 * @returns An array of Whitelisted Configuration Settings
 */
export function getConfigurationSettingsApplicationId(
  this: unknown,
  applicationId: number
) {
  return withJwt(() =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).configurationSettingsUrl
        }/application/${encodeURIComponent(applicationId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...new AuthHeaders(), // Doesn't work with JWT for some reason
          },
        }
      )
    )
  ).pipe(selectData(z.array(whitelistedConfigurationSettingSchema)));
}
